var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeSafeSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6046 29.6044C37.9678 28.2412 37.9678 26.031 36.6046 24.6679C35.2414 23.3047 33.0313 23.3047 31.6681 24.6679C30.3049 26.031 30.3049 28.2412 31.6681 29.6044C33.0313 30.9675 35.2414 30.9675 36.6046 29.6044ZM37.9546 30.9543C40.0633 28.8456 40.0633 25.4266 37.9546 23.3179C35.8458 21.2092 32.4269 21.2092 30.3182 23.3179C28.2095 25.4266 28.2095 28.8456 30.3182 30.9543C32.4269 33.063 35.8458 33.063 37.9546 30.9543Z",
    fill: "#00A88E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2454 34.7722L36.4272 30.9541L37.7771 29.6041L41.5953 33.4223L40.2454 34.7722Z",
    fill: "#00A88E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4998 20.9998V8.62476H5.87476V29.6248H27.6248",
    stroke: "#1D1D1B",
    strokeWidth: 1.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 19.1249L18.4375 23.3468L18.4375 14.903L25.75 19.1249Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSafeSearch);
export default __webpack_public_path__ + "static/media/youtube-safe-search.16d222cc87b670251de33f77c2855235.svg";
export { ForwardRef as ReactComponent };